import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useState } from "react";
import { Col, Row } from "react-styled-flexboxgrid";
import Public from "../../../Layouts/Public";
import PersonalAppFeatures from "../../../components/AppFeatures/PersonalAppFeatures";
import Button from "../../../components/Button/Button";
import EarlyBirdOfferModal from "../../../components/EarlyBirdOffer/EarlyBirdOfferModal";
import HeroSection from "../../../components/HeroSection";
import BannerText from "../../../components/Public/Business/BannerText";
import Features from "../../../components/Public/Business/Features";
import { siteTitle } from "../../../data/PublicSiteData";
import { trackPageView } from "../../../includes/analytics";

const AccommodationPage = () => {
  const router = useRouter();
  const [showConsentModal, setShowConsentModal] = useState(false);

  const heroImage = (
    <img
      src={`/img/app-screenshots/hero-phone-accommodation.png`}
      alt="Valmeego.com - Locally and beyond"
      style={{ width: "100%", maxWidth: "338px", height: "auto" }}
    />
  );

  trackPageView("/business/accommodation");

  return (
    <>
      <NextSeo
        title={`Valmeego for Accommodation | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      {showConsentModal && (
        <EarlyBirdOfferModal
          setShowConsentModal={setShowConsentModal}
          showConsentModal={showConsentModal}
        />
      )}
      <HeroSection
        background={`/img/header-backgrounds/accommodation.webp`}
        image={heroImage}
      >
        <Row center="xs">
          <Col xs={10} sm={10} md={10} lg={12}>
            <BannerText businessType="Accommodation" />
            <Row>
              <Col xs={12}>
                <Button
                  dataCy="hero-signup-button"
                  color="primary"
                  label="Sign up"
                  size="extra-large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </HeroSection>

      <Features
        fillerImageOneURL="/img/content/accommodation.webp"
        fillerImageTwoURL="/img/content/breakfast.png"
      />
      <PersonalAppFeatures />
    </>
  );
};

AccommodationPage.Layout = Public;
AccommodationPage.Title = "Valmeego - Locally and beyond";

export default AccommodationPage;
